import React from 'react';
import BasicDialog, { IBasicDialog } from '../Dialog/BasicDialog';
import Toast, { IToast } from '../Dialog/Toast';
import { observer, inject } from 'mobx-react';
import RootStore from '../../store/RootStore';

export interface IWxCommon {
  rootStore?: RootStore;
}

@inject('rootStore')
@observer
class Common extends React.Component<IWxCommon, any> {
  render() {
    const { uiStore } = this.props.rootStore!;
    const { toast = {} as IToast, basicDialog = {} as IBasicDialog } = uiStore;
    return (
      <>
        {toast.show ? <Toast content={toast.content} /> : null}
        {basicDialog.show ? <BasicDialog
          title={basicDialog.title}
          content={basicDialog.content}
          show={basicDialog.show}
          onOk={basicDialog.onOk}
          okText={basicDialog.okText}
          cancelText={basicDialog.cancelText}
          onCancel={basicDialog.onCancel}
          showCancel={basicDialog.showCancel}
          wrapClassName={basicDialog.wrapClassName}
        /> : null}
      </>
    );
  }
}

export default Common;
